import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import { makeSelectorToGeoJsonNamesDict, getKeyForValue } from '../../DataPrep';
import { useDataState } from '../../../DataContext'

const generateTickValues = () => {
    const startMonth = 5; // May
    const endMonth = 12; // December
    const year = 2023;
    const tickValues = [];
  
    for (let i = startMonth; i <= endMonth; i++) {
      tickValues.push(new Date(year, i - 1, 1));
    }
  
    return tickValues;
  };

const TimeSeriesCard = ({ id, dataSeries }) => {

    // App state management; see DataContext.js
    const {
        userGroup,
    } = useDataState();

    let selectorToGeoJsonNamesDict = makeSelectorToGeoJsonNamesDict(userGroup);

    return (
        <Card elevation={3} style={{ borderRadius: '15px' }}>
        <CardContent>
            <Typography align="center" style={{ marginBottom: '14px' }}>
            {getKeyForValue(id, selectorToGeoJsonNamesDict)}
            </Typography>
            <div style={{ height: '150px' }}>
            <ResponsiveLine
                data={dataSeries}
                margin={{ top: 10, right: 30, bottom: 30, left: 30 }}
                xScale={{
                    type: 'time',
                    format: '%Y-%m-%d',
                    precision: 'day',
                    min: '2023-05-01',
                    max: '2023-09-31',
                  }}
                xFormat="time:%Y-%m-%d"
                yScale={{ 
                    type: 'linear', 
                    min: 'auto', 
                    max: 'auto', 
                    stacked: false, 
                    reverse: false 
                }}
                axisBottom={{
                    orient: 'bottom',
                    tickValues: generateTickValues(),
                    tickPadding: 5,
                    tickRotation: 0,
                    format: '%b',
                    legend: 'Date',
                    title: null,
                    legendPosition: 'middle',
                    legendOffset: 46,
                  }}
                axisLeft={{
                    tickValues: 5,
                    orient: 'left',
                    tickPadding: 2,
                    tickRotation: 0,
                    legend: null,
                    legendPosition: 'middle',
                    legendOffset: -60,
                }}
                enableGridX={false}
                enableGridY={false}
                enableSlices="x"
                sliceTooltip={({ slice }) => {
                    const sortedPoints = [...slice.points].sort((a, b) => b.data.y - a.data.y);
                    
                    return (
                        <div
                        style={{
                            background: 'white',
                            padding: '12px 12px',
                            border: '1px solid #ccc',
                        }}
                        >
                        {/* <div>Date: {slice.points[0].data.xFormatted}</div> */}
                        {sortedPoints.map(point => (
                            <div key={point.id} style={{ color: point.color, fontSize: '14px' }}>
                            {point.serieId}: {parseFloat(point.data.y).toFixed(1)}
                            </div>
                        ))}
                        </div>
                    );
                    }}
                    
                    theme={{
                        axis: {
                            domain: {
                                line: {
                                    stroke: '#777777',
                                    strokeWidth: 1
                                }
                            },
                            ticks: {
                                text: {
                                fontSize: 14
                                }
                            },
                            legend: {
                                text: {
                                fontSize: 14
                                }
                            }
                        }
                      }}
                />
            </div>
        </CardContent>
        </Card>
    );
};

export default TimeSeriesCard;
